<template>
  <component :is="tag" class="button button--secondary caret-button">
    <slot />
    <Caret />
  </component>
</template>

<script>
  import { defineComponent } from 'vue'
  import Caret from '@/components/icons/Caret.vue'

  export default defineComponent({
    components: { Caret },
    props: {
      tag: {
        type: String,
        default: 'button',
      },
    },
  })
</script>

<style lang="scss" scoped>
  .caret-button {
    display: block;

    &[aria-expanded="true"] {
      .icon {
        transform: rotate(-90deg);
      }
    }

    .icon {
      height: 1.3em;
      transform: rotate(90deg);
      transition: transform 0.1s ease-out;
      transform-origin: 50% 55%;
      pointer-events: none;
    }
  }
</style>
